// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   HomeFaqPage — "Questions before you start."
   Prefix: home_faq_pg_ · no :root variables · no green
   ============================================================ */

.home_faq_pg_wrapper {
  position: relative;
  width: 100%;
  padding: 72px 24px 88px;
  background: linear-gradient(180deg, #f1e9fc 0%, #f4edfd 100%);
  font-family: "Sora", "Manrope", sans-serif;
  color: #0f0a2a;
  overflow: hidden;
  isolation: isolate;
}

.home_faq_pg_wrapper *,
.home_faq_pg_wrapper *::before,
.home_faq_pg_wrapper *::after {
  box-sizing: border-box;
}

/* soft glow behind the list */
.home_faq_pg_wrapper::before {
  content: "";
  position: absolute;
  z-index: -1;
  top: -120px;
  right: -140px;
  width: 520px;
  height: 520px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(138, 80, 230, 0.2) 0%, rgba(138, 80, 230, 0) 70%);
  pointer-events: none;
}

.home_faq_pg_container {
  display: grid;
  grid-template-columns: minmax(0, 0.8fr) minmax(0, 1.2fr);
  align-items: start;
  column-gap: 84px;
  max-width: 1060px;
  margin: 0 auto;
}

/* ============================================================
   Left: intro
   ============================================================ */

.home_faq_pg_intro {
  position: sticky;
  top: 110px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 0;
}

.home_faq_pg_tagline {
  margin: 0 0 10px;
  font-size: 11.5px;
  font-weight: 800;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #4a1a9e;
}

.home_faq_pg_heading {
  margin: 0 0 14px;
  font-size: clamp(30px, 3.8vw, 42px);
  font-weight: 800;
  line-height: 1.12;
  letter-spacing: -0.02em;
  color: #0f0a2a;
  text-wrap: balance;
}

.home_faq_pg_subtext {
  max-width: 330px;
  margin: 0 0 24px;
  font-size: 15px;
  line-height: 1.65;
  color: #5d5978;
}

.home_faq_pg_ask {
  position: relative;
  padding: 12px 24px;
  border: 1px solid #e4dcf9;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 8px 20px rgba(74, 26, 158, 0.08);
  font-family: inherit;
  font-size: 13.5px;
  font-weight: 800;
  color: #4a1a9e;
  cursor: pointer;
  overflow: hidden;
  isolation: isolate;
  transition: color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
}

/* purple fill sweeping in on hover */
.home_faq_pg_ask::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: -1;
  background: linear-gradient(100deg, #4a1a9e 0%, #6a1fc2 100%);
  transform: translateX(-101%);
  transition: transform 0.4s cubic-bezier(0.22, 1, 0.36, 1);
}

.home_faq_pg_ask:hover {
  color: #ffffff;
  border-color: #4a1a9e;
  transform: translateY(-3px);
  box-shadow: 0 14px 28px rgba(74, 26, 158, 0.28);
}

.home_faq_pg_ask:hover::before {
  transform: translateX(0);
}

.home_faq_pg_ask:active {
  transform: translateY(0) scale(0.97);
}

.home_faq_pg_ask:focus-visible,
.home_faq_pg_question_row:focus-visible {
  outline: 3px solid #e0a83d;
  outline-offset: 3px;
}

/* ============================================================
   Right: accordion
   ============================================================ */

.home_faq_pg_list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 0;
}

.home_faq_pg_item {
  border: 1px solid rgba(228, 220, 249, 0.9);
  border-radius: 12px;
  background: linear-gradient(160deg, #ffffff 0%, #faf6ff 100%);
  box-shadow: 0 10px 24px rgba(74, 26, 158, 0.09);
  overflow: hidden;
  transition: box-shadow 0.35s ease, border-color 0.35s ease, transform 0.35s ease;
}

.home_faq_pg_item:hover {
  transform: translateY(-2px);
  border-color: #cdbcf2;
  box-shadow: 0 16px 32px rgba(74, 26, 158, 0.15);
}

.home_faq_pg_item_open {
  border-color: #b9a1ec;
  box-shadow: 0 20px 40px rgba(74, 26, 158, 0.18);
}

.home_faq_pg_question_head {
  margin: 0;
  font-size: inherit;
  font-weight: inherit;
}

.home_faq_pg_question_row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  padding: 18px 18px 18px 18px;
  border: 0;
  background: transparent;
  font-family: inherit;
  text-align: left;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

.home_faq_pg_question {
  flex: 1 1;
  min-width: 0;
  font-size: 14.5px;
  font-weight: 800;
  line-height: 1.4;
  color: #0f0a2a;
}

.home_faq_pg_icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  flex-shrink: 0;
  border-radius: 50%;
  background: #ecdcfa;
  color: #6a1fc2;
  transition:
    transform 0.5s cubic-bezier(0.34, 1.56, 0.64, 1),
    background 0.3s ease,
    color 0.3s ease;
}

.home_faq_pg_question_row:hover .home_faq_pg_icon {
  background: #dcc6f6;
}

.home_faq_pg_item_open .home_faq_pg_icon {
  transform: rotate(135deg);
  background: linear-gradient(135deg, #4a1a9e 0%, #6a1fc2 100%);
  color: #ffffff;
}

/* smooth open / close: row height animates between 0fr and 1fr */
.home_faq_pg_answer_wrap {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.5s cubic-bezier(0.22, 1, 0.36, 1);
}

.home_faq_pg_item_open .home_faq_pg_answer_wrap {
  grid-template-rows: 1fr;
}

.home_faq_pg_answer_inner {
  min-height: 0;
  overflow: hidden;
}

.home_faq_pg_answer {
  margin: 0;
  padding: 0 64px 20px 18px;
  font-size: 14px;
  line-height: 1.7;
  color: #5d5978;
  opacity: 0;
  transform: translateY(-8px);
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.home_faq_pg_item_open .home_faq_pg_answer {
  opacity: 1;
  transform: none;
  transition: opacity 0.5s ease 0.15s, transform 0.5s cubic-bezier(0.22, 1, 0.36, 1) 0.15s;
}

/* ============================================================
   Entrance (plays once on scroll)
   ============================================================ */

.home_faq_pg_reveal {
  opacity: 0;
  transform: translateY(26px);
  transition:
    opacity 0.8s ease var(--d, 0ms),
    transform 0.9s cubic-bezier(0.22, 1, 0.36, 1) var(--d, 0ms);
}

.home_faq_pg_in .home_faq_pg_reveal {
  opacity: 1;
  transform: none;
}

/* the button keeps its quick hover transitions after it has appeared */
.home_faq_pg_in .home_faq_pg_ask.home_faq_pg_reveal {
  transition:
    opacity 0.8s ease var(--d, 0ms),
    transform 0.3s ease,
    box-shadow 0.3s ease,
    color 0.3s ease,
    border-color 0.3s ease;
}

/* items fade up one after another */
.home_faq_pg_item {
  opacity: 0;
  transform: translateY(30px);
}

.home_faq_pg_in .home_faq_pg_item {
  animation: home_faq_pg_rise 0.8s cubic-bezier(0.22, 1, 0.36, 1) both;
  animation-delay: calc(var(--i, 0) * 90ms + 250ms);
  opacity: 1;
  transform: none;
}

@keyframes home_faq_pg_rise {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ============================================================
   Responsive — 1100 / 900 / 560 / 360
   ============================================================ */

@media (max-width: 1100px) {
  .home_faq_pg_wrapper {
    padding: 60px 20px 76px;
  }

  .home_faq_pg_container {
    column-gap: 48px;
  }
}

/* stack: intro on top, questions below */
@media (max-width: 900px) {
  .home_faq_pg_wrapper {
    padding: 52px 20px 68px;
  }

  .home_faq_pg_container {
    grid-template-columns: minmax(0, 1fr);
    row-gap: 36px;
    max-width: 680px;
  }

  .home_faq_pg_intro {
    position: static;
  }

  .home_faq_pg_subtext {
    max-width: 480px;
  }
}

@media (max-width: 560px) {
  .home_faq_pg_wrapper {
    padding: 44px 14px 56px;
  }

  .home_faq_pg_container {
    row-gap: 28px;
  }

  .home_faq_pg_subtext {
    margin-bottom: 20px;
    font-size: 14.5px;
  }

  .home_faq_pg_ask {
    width: 100%;
    padding: 14px 20px;
  }

  .home_faq_pg_list {
    gap: 9px;
  }

  .home_faq_pg_question_row {
    gap: 12px;
    padding: 16px 14px;
  }

  .home_faq_pg_question {
    font-size: 14px;
  }

  .home_faq_pg_icon {
    width: 28px;
    height: 28px;
  }

  .home_faq_pg_answer {
    padding: 0 14px 18px 14px;
    font-size: 13.5px;
  }
}

@media (max-width: 360px) {
  .home_faq_pg_question {
    font-size: 13.5px;
  }
}

/* ============================================================
   Reduced motion
   ============================================================ */

@media (prefers-reduced-motion: reduce) {
  .home_faq_pg_reveal,
  .home_faq_pg_item {
    opacity: 1 !important;
    transform: none !important;
    transition: none !important;
    animation: none !important;
  }

  .home_faq_pg_answer_wrap,
  .home_faq_pg_answer,
  .home_faq_pg_icon {
    transition: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/HomeFaqPage/HomeFaqPage.css"],"names":[],"mappings":"AAAA;;;iEAGiE;;AAEjE;EACE,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,6DAA6D;EAC7D,0CAA0C;EAC1C,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA,8BAA8B;AAC9B;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,aAAa;EACb,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,0FAA0F;EAC1F,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,wDAAwD;EACxD,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;iEAEiE;;AAEjE;EACE,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,8CAA8C;EAC9C,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,8FAA8F;AAChG;;AAEA,qCAAqC;AACrC;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,6DAA6D;EAC7D,4BAA4B;EAC5B,yDAAyD;AAC3D;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;;iEAEiE;;AAEjE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;EACnB,6DAA6D;EAC7D,+CAA+C;EAC/C,gBAAgB;EAChB,gFAAgF;AAClF;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,4BAA4B;EAC5B,SAAS;EACT,uBAAuB;EACvB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd;;;mBAGiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,6DAA6D;EAC7D,cAAc;AAChB;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,uBAAuB;EACvB,kEAAkE;AACpE;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,2BAA2B;EAC3B,kDAAkD;AACpD;;AAEA;EACE,UAAU;EACV,eAAe;EACf,wFAAwF;AAC1F;;AAEA;;iEAEiE;;AAEjE;EACE,UAAU;EACV,2BAA2B;EAC3B;;+DAE6D;AAC/D;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA,uEAAuE;AACvE;EACE;;;;;0BAKwB;AAC1B;;AAEA,oCAAoC;AACpC;EACE,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,oEAAoE;EACpE,iDAAiD;EACjD,UAAU;EACV,eAAe;AACjB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;;iEAEiE;;AAEjE;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,yCAAyC;AACzC;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,qCAAqC;IACrC,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;;iEAEiE;;AAEjE;EACE;;IAEE,qBAAqB;IACrB,0BAA0B;IAC1B,2BAA2B;IAC3B,0BAA0B;EAC5B;;EAEA;;;IAGE,2BAA2B;EAC7B;AACF","sourcesContent":["/* ============================================================\n   HomeFaqPage — \"Questions before you start.\"\n   Prefix: home_faq_pg_ · no :root variables · no green\n   ============================================================ */\n\n.home_faq_pg_wrapper {\n  position: relative;\n  width: 100%;\n  padding: 72px 24px 88px;\n  background: linear-gradient(180deg, #f1e9fc 0%, #f4edfd 100%);\n  font-family: \"Sora\", \"Manrope\", sans-serif;\n  color: #0f0a2a;\n  overflow: hidden;\n  isolation: isolate;\n}\n\n.home_faq_pg_wrapper *,\n.home_faq_pg_wrapper *::before,\n.home_faq_pg_wrapper *::after {\n  box-sizing: border-box;\n}\n\n/* soft glow behind the list */\n.home_faq_pg_wrapper::before {\n  content: \"\";\n  position: absolute;\n  z-index: -1;\n  top: -120px;\n  right: -140px;\n  width: 520px;\n  height: 520px;\n  border-radius: 50%;\n  background: radial-gradient(circle, rgba(138, 80, 230, 0.2) 0%, rgba(138, 80, 230, 0) 70%);\n  pointer-events: none;\n}\n\n.home_faq_pg_container {\n  display: grid;\n  grid-template-columns: minmax(0, 0.8fr) minmax(0, 1.2fr);\n  align-items: start;\n  column-gap: 84px;\n  max-width: 1060px;\n  margin: 0 auto;\n}\n\n/* ============================================================\n   Left: intro\n   ============================================================ */\n\n.home_faq_pg_intro {\n  position: sticky;\n  top: 110px;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  min-width: 0;\n}\n\n.home_faq_pg_tagline {\n  margin: 0 0 10px;\n  font-size: 11.5px;\n  font-weight: 800;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: #4a1a9e;\n}\n\n.home_faq_pg_heading {\n  margin: 0 0 14px;\n  font-size: clamp(30px, 3.8vw, 42px);\n  font-weight: 800;\n  line-height: 1.12;\n  letter-spacing: -0.02em;\n  color: #0f0a2a;\n  text-wrap: balance;\n}\n\n.home_faq_pg_subtext {\n  max-width: 330px;\n  margin: 0 0 24px;\n  font-size: 15px;\n  line-height: 1.65;\n  color: #5d5978;\n}\n\n.home_faq_pg_ask {\n  position: relative;\n  padding: 12px 24px;\n  border: 1px solid #e4dcf9;\n  border-radius: 8px;\n  background: #ffffff;\n  box-shadow: 0 8px 20px rgba(74, 26, 158, 0.08);\n  font-family: inherit;\n  font-size: 13.5px;\n  font-weight: 800;\n  color: #4a1a9e;\n  cursor: pointer;\n  overflow: hidden;\n  isolation: isolate;\n  transition: color 0.3s ease, transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;\n}\n\n/* purple fill sweeping in on hover */\n.home_faq_pg_ask::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  z-index: -1;\n  background: linear-gradient(100deg, #4a1a9e 0%, #6a1fc2 100%);\n  transform: translateX(-101%);\n  transition: transform 0.4s cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n.home_faq_pg_ask:hover {\n  color: #ffffff;\n  border-color: #4a1a9e;\n  transform: translateY(-3px);\n  box-shadow: 0 14px 28px rgba(74, 26, 158, 0.28);\n}\n\n.home_faq_pg_ask:hover::before {\n  transform: translateX(0);\n}\n\n.home_faq_pg_ask:active {\n  transform: translateY(0) scale(0.97);\n}\n\n.home_faq_pg_ask:focus-visible,\n.home_faq_pg_question_row:focus-visible {\n  outline: 3px solid #e0a83d;\n  outline-offset: 3px;\n}\n\n/* ============================================================\n   Right: accordion\n   ============================================================ */\n\n.home_faq_pg_list {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  min-width: 0;\n}\n\n.home_faq_pg_item {\n  border: 1px solid rgba(228, 220, 249, 0.9);\n  border-radius: 12px;\n  background: linear-gradient(160deg, #ffffff 0%, #faf6ff 100%);\n  box-shadow: 0 10px 24px rgba(74, 26, 158, 0.09);\n  overflow: hidden;\n  transition: box-shadow 0.35s ease, border-color 0.35s ease, transform 0.35s ease;\n}\n\n.home_faq_pg_item:hover {\n  transform: translateY(-2px);\n  border-color: #cdbcf2;\n  box-shadow: 0 16px 32px rgba(74, 26, 158, 0.15);\n}\n\n.home_faq_pg_item_open {\n  border-color: #b9a1ec;\n  box-shadow: 0 20px 40px rgba(74, 26, 158, 0.18);\n}\n\n.home_faq_pg_question_head {\n  margin: 0;\n  font-size: inherit;\n  font-weight: inherit;\n}\n\n.home_faq_pg_question_row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  width: 100%;\n  padding: 18px 18px 18px 18px;\n  border: 0;\n  background: transparent;\n  font-family: inherit;\n  text-align: left;\n  cursor: pointer;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.home_faq_pg_question {\n  flex: 1;\n  min-width: 0;\n  font-size: 14.5px;\n  font-weight: 800;\n  line-height: 1.4;\n  color: #0f0a2a;\n}\n\n.home_faq_pg_icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  flex-shrink: 0;\n  border-radius: 50%;\n  background: #ecdcfa;\n  color: #6a1fc2;\n  transition:\n    transform 0.5s cubic-bezier(0.34, 1.56, 0.64, 1),\n    background 0.3s ease,\n    color 0.3s ease;\n}\n\n.home_faq_pg_question_row:hover .home_faq_pg_icon {\n  background: #dcc6f6;\n}\n\n.home_faq_pg_item_open .home_faq_pg_icon {\n  transform: rotate(135deg);\n  background: linear-gradient(135deg, #4a1a9e 0%, #6a1fc2 100%);\n  color: #ffffff;\n}\n\n/* smooth open / close: row height animates between 0fr and 1fr */\n.home_faq_pg_answer_wrap {\n  display: grid;\n  grid-template-rows: 0fr;\n  transition: grid-template-rows 0.5s cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n.home_faq_pg_item_open .home_faq_pg_answer_wrap {\n  grid-template-rows: 1fr;\n}\n\n.home_faq_pg_answer_inner {\n  min-height: 0;\n  overflow: hidden;\n}\n\n.home_faq_pg_answer {\n  margin: 0;\n  padding: 0 64px 20px 18px;\n  font-size: 14px;\n  line-height: 1.7;\n  color: #5d5978;\n  opacity: 0;\n  transform: translateY(-8px);\n  transition: opacity 0.3s ease, transform 0.3s ease;\n}\n\n.home_faq_pg_item_open .home_faq_pg_answer {\n  opacity: 1;\n  transform: none;\n  transition: opacity 0.5s ease 0.15s, transform 0.5s cubic-bezier(0.22, 1, 0.36, 1) 0.15s;\n}\n\n/* ============================================================\n   Entrance (plays once on scroll)\n   ============================================================ */\n\n.home_faq_pg_reveal {\n  opacity: 0;\n  transform: translateY(26px);\n  transition:\n    opacity 0.8s ease var(--d, 0ms),\n    transform 0.9s cubic-bezier(0.22, 1, 0.36, 1) var(--d, 0ms);\n}\n\n.home_faq_pg_in .home_faq_pg_reveal {\n  opacity: 1;\n  transform: none;\n}\n\n/* the button keeps its quick hover transitions after it has appeared */\n.home_faq_pg_in .home_faq_pg_ask.home_faq_pg_reveal {\n  transition:\n    opacity 0.8s ease var(--d, 0ms),\n    transform 0.3s ease,\n    box-shadow 0.3s ease,\n    color 0.3s ease,\n    border-color 0.3s ease;\n}\n\n/* items fade up one after another */\n.home_faq_pg_item {\n  opacity: 0;\n  transform: translateY(30px);\n}\n\n.home_faq_pg_in .home_faq_pg_item {\n  animation: home_faq_pg_rise 0.8s cubic-bezier(0.22, 1, 0.36, 1) both;\n  animation-delay: calc(var(--i, 0) * 90ms + 250ms);\n  opacity: 1;\n  transform: none;\n}\n\n@keyframes home_faq_pg_rise {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* ============================================================\n   Responsive — 1100 / 900 / 560 / 360\n   ============================================================ */\n\n@media (max-width: 1100px) {\n  .home_faq_pg_wrapper {\n    padding: 60px 20px 76px;\n  }\n\n  .home_faq_pg_container {\n    column-gap: 48px;\n  }\n}\n\n/* stack: intro on top, questions below */\n@media (max-width: 900px) {\n  .home_faq_pg_wrapper {\n    padding: 52px 20px 68px;\n  }\n\n  .home_faq_pg_container {\n    grid-template-columns: minmax(0, 1fr);\n    row-gap: 36px;\n    max-width: 680px;\n  }\n\n  .home_faq_pg_intro {\n    position: static;\n  }\n\n  .home_faq_pg_subtext {\n    max-width: 480px;\n  }\n}\n\n@media (max-width: 560px) {\n  .home_faq_pg_wrapper {\n    padding: 44px 14px 56px;\n  }\n\n  .home_faq_pg_container {\n    row-gap: 28px;\n  }\n\n  .home_faq_pg_subtext {\n    margin-bottom: 20px;\n    font-size: 14.5px;\n  }\n\n  .home_faq_pg_ask {\n    width: 100%;\n    padding: 14px 20px;\n  }\n\n  .home_faq_pg_list {\n    gap: 9px;\n  }\n\n  .home_faq_pg_question_row {\n    gap: 12px;\n    padding: 16px 14px;\n  }\n\n  .home_faq_pg_question {\n    font-size: 14px;\n  }\n\n  .home_faq_pg_icon {\n    width: 28px;\n    height: 28px;\n  }\n\n  .home_faq_pg_answer {\n    padding: 0 14px 18px 14px;\n    font-size: 13.5px;\n  }\n}\n\n@media (max-width: 360px) {\n  .home_faq_pg_question {\n    font-size: 13.5px;\n  }\n}\n\n/* ============================================================\n   Reduced motion\n   ============================================================ */\n\n@media (prefers-reduced-motion: reduce) {\n  .home_faq_pg_reveal,\n  .home_faq_pg_item {\n    opacity: 1 !important;\n    transform: none !important;\n    transition: none !important;\n    animation: none !important;\n  }\n\n  .home_faq_pg_answer_wrap,\n  .home_faq_pg_answer,\n  .home_faq_pg_icon {\n    transition: none !important;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
